module.exports = __webpack_public_path__ + "static/img/dbq0616.4f2790c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dbq0616.jpg
// module id = TVOT
// module chunks = 0